import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

// Checks if passwords match
export function passwordMatchValidator(password: string, passwordConfirmation: string): ValidatorFn {
	return (group: UntypedFormGroup) => {
		if (!group.get(password).value || !group.get(passwordConfirmation).value) {
			return null;
		}
		return group.get(password).value !== group.get(passwordConfirmation).value ? { passwordMatch: true } : null;
	};
}
